import { BaseButton } from '../BaseButton/BaseButton';

export const BaseButtonOutline = (props) => {
  const { children, ...rest } = props;

  return (
    <BaseButton outline {...rest}>
      {children}
    </BaseButton>
  );
};

export default BaseButtonOutline;
